module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/suTMtU/tc-custom/9781613766897.jpg?1726574123016",
      "alt": "This image is the cover for the book Sacking of Fallujah, Culture and Politics in the Cold War and Beyond"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sacking of Fallujah, Culture and Politics in the Cold War and Beyond\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Iraqi city of Fallujah has become an epicenter of geopolitical conflict, where foreign powers and non-state actors have repeatedly waged war in residential neighborhoods with staggering humanitarian consequences. "), _c('i', [_vm._v("The Sacking of Fallujah")]), _vm._v(" is the first comprehensive study of the three recent sieges of this city, including those by the United States in 2004 and the Iraqi-led operation to defeat ISIS in 2016."), _c('br'), _c('br'), _vm._v(" Unlike dominant military accounts that focus on American soldiers and U.S. leaders and perpetuate the myth that the United States \"liberated\" the city, this book argues that Fallujah was destroyed by coalition forces, leaving public health crises, political destabilization, and mass civilian casualties in their wake. This meticulously researched account cuts through the propaganda to uncover the lived experiences of Fallujans under siege and occupation, and contextualizes these events within a broader history of U.S. policy in the Middle East. Relying on testimony from Iraqi civilians, the work of independent journalists, and documentation from human rights organizations, Ross Caputi, Richard Hil, and Donna Mulhearn place the experiences of Fallujah's residents at the center of this city's recent history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ross Caputi, Richard Hil, Donna Mulhearn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Massachusetts Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0